import { render, staticRenderFns } from "./events.vue?vue&type=template&id=30b02a51&scoped=true"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"
import style0 from "./events.vue?vue&type=style&index=0&id=30b02a51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b02a51",
  null
  
)

export default component.exports